var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("campus-signup", {
    staticClass: "my-3 my-md-5 rounded",
    attrs: {
      "contact-id": this.contactId,
      "contact-type": this.contactType,
      "parent-merchant-id": this.merchantId,
      "type-merchant": this.typeMerchant,
      "type-wholesaler": this.typeWholesaler,
      "type-admin": this.typeAdmin,
      merchants: this.merchants
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }